import React from "react";
import './Navigation.css'

function Navigation() {
  return (
    <nav>
      <ul>
        <li><a href="#About">About</a></li>
        <li><a href="#Projects">Projects</a></li>
        <li><a href="#Technologies">Technologies</a></li>
        <li><a href="#Education">Education</a></li>
        <li><a href="#Contact">Contact</a></li>
      </ul>
    </nav>
  )
}
export default Navigation